import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "regenerator-runtime/runtime.js";
import dsteem from "../unit/DsteemUtil";
import { extractLoginData, getAccount } from "../unit/UserUtil";
import PostCard from "../components/PostComponents/PostCard.vue";
import CommunityCard from "../components/CommunityComponents/CommunityCard.vue";
import { Search } from "@element-plus/icons-vue";
import { $t } from "../plugins/i18n";
export default {
  components: {
    PostCard: PostCard,
    CommunityCard: CommunityCard
  },
  data: function data() {
    return {
      loginData: null,
      editableTabsValue: "1",
      editableTabs: [{
        title: $t("label.allPost"),
        name: "1",
        blogs: []
      }, {
        title: $t("label.communites"),
        name: "2",
        communities: []
      }],
      tabIndex: 2,
      keyWord: "",
      Search: Search,
      selectPost: "created",
      selectPostOption: [{
        key: "New",
        value: "created"
      }, {
        key: "Trending",
        value: "trending"
      }, {
        key: "Hot",
        value: "hot"
      }, {
        key: "Promoted",
        value: "promoted"
      }],
      selectCommunity: "Rank",
      selectCommunityOption: [{
        key: "Rank",
        value: "Rank"
      }, {
        key: "Subscribers",
        value: "Subscribers"
      }, {
        key: "New",
        value: "New"
      }, {
        key: "Muted",
        value: "muted"
      }]
    };
  },
  methods: {
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loginData = extractLoginData();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onRefresh: function onRefresh(done) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dsteem.getBlogsByBridge(_this2.loginData ? _this2.loginData[0] : null, "trending", "", 20);

              case 2:
                _this2.editableTabs[0].blogs = _context2.sent;
                done();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    loadCommunities: function loadCommunities() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var communities;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dsteem.getCommunities(_this3.loginData ? _this3.loginData[0] : null, _this3.keyWord, _this3.selectCommunity.toLowerCase());

              case 2:
                communities = _context3.sent;
                _this3.editableTabs[1].communities = communities;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onLoad: function onLoad(done) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var permlink, author, nextblogs;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.editableTabs[0].blogs[_this4.editableTabs[0].blogs.length - 1]) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                permlink = _this4.editableTabs[0].blogs[_this4.editableTabs[0].blogs.length - 1].permlink;
                author = _this4.editableTabs[0].blogs[_this4.editableTabs[0].blogs.length - 1].author;
                _context4.next = 6;
                return dsteem.getBlogsByBridge(_this4.loginData ? _this4.loginData[0] : null, _this4.selectPost.toLowerCase(), "", 20, permlink, author);

              case 6:
                nextblogs = _context4.sent;
                nextblogs.shift();

                _this4.editableTabs[0].blogs.push.apply(_this4.editableTabs[0].blogs, nextblogs);

                done();

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    addTab: function addTab(targetName) {
      var newTabName = ++this.tabIndex + "";
      this.editableTabs.push({
        title: "New Tab",
        name: newTabName,
        content: "New Tab content"
      });
      this.editableTabsValue = newTabName;
    },
    removeTab: function removeTab(targetName) {
      var tabs = this.editableTabs;
      var activeName = this.editableTabsValue;

      if (activeName === targetName) {
        tabs.forEach(function (tab, index) {
          if (tab.name === targetName) {
            var nextTab = tabs[index + 1] || tabs[index - 1];

            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter(function (tab) {
        return tab.name !== targetName;
      });
    },
    changeTab: function changeTab(targetName) {
      this.editableTabsValue = targetName;
    },
    searchResult: function searchResult() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.loadCommunities();

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  },
  watch: {
    selectPost: function selectPost() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return dsteem.getBlogsByBridge(_this6.loginData ? _this6.loginData[0] : null, _this6.selectPost.toLowerCase(), "", 20);

              case 2:
                _this6.editableTabs[0].blogs = _context6.sent;

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this7.loadAccount();

            case 2:
              _context7.next = 4;
              return dsteem.getBlogsByBridge(_this7.loginData ? _this7.loginData[0] : null, _this7.selectPost.toLowerCase(), "", 20);

            case 4:
              _this7.editableTabs[0].blogs = _context7.sent;

              _this7.loadCommunities();

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }
};